export const SUPPORT_CATEGORIES = [
  { value: 'GENERAL', label: 'General' },
  { value: 'TECHNICAL', label: 'Technical' },
  { value: 'BUG_REPORT', label: 'Bug report' },
  { value: 'FEATURE_REQUEST', label: 'Feature request' },
  { value: 'BILLING', label: 'Billing' },
  { value: 'TRAINING', label: 'Training' },
  { value: 'INTEGRATION', label: 'Integration' }
];

export const SUPPORT_PRIORITIES = [
  { value: 'LOW', label: 'Low' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH', label: 'High' },
  { value: 'URGENT', label: 'Urgent' },
  { value: 'CRITICAL', label: 'Critical' }
];

export const SUPPORT_STATUSES = [
  { value: 'OPEN', label: 'Open' },
  { value: 'IN_PROGRESS', label: 'In progress' },
  { value: 'WAITING_FOR_CUSTOMER', label: 'Waiting for you' },
  { value: 'RESOLVED', label: 'Resolved' },
  { value: 'CLOSED', label: 'Closed' }
];

export const SUPPORT_MODULES = [
  { value: '', label: 'General workspace' },
  { value: 'workspace', label: 'Workspace home' },
  { value: 'tender', label: 'Tender Management' },
  { value: 'users', label: 'Users & roles' },
  { value: 'onboarding', label: 'Company setup' },
  { value: 'ai', label: 'AI assistant' }
];

export function supportBasePath(pathname) {
  return String(pathname || '').startsWith('/apps/tender')
    ? '/apps/tender/support'
    : '/platform/support';
}

export function labelFor(value, list) {
  return list.find((o) => o.value === value)?.label || value || '—';
}

export function moduleLabel(key) {
  return labelFor(key, SUPPORT_MODULES);
}

export function categoryLabel(key) {
  return labelFor(key, SUPPORT_CATEGORIES);
}

export function priorityVariant(priority) {
  const p = String(priority || '').toUpperCase();
  if (p === 'CRITICAL' || p === 'URGENT') return 'critical';
  if (p === 'HIGH') return 'high';
  if (p === 'LOW') return 'low';
  return 'medium';
}

export function statusVariant(status) {
  const s = String(status || '').toUpperCase();
  if (s === 'OPEN') return 'open';
  if (s === 'IN_PROGRESS') return 'progress';
  if (s === 'RESOLVED' || s === 'CLOSED') return 'resolved';
  if (s === 'WAITING_FOR_CUSTOMER') return 'waiting';
  return 'neutral';
}
